import { render, staticRenderFns } from "./text.vue?vue&type=template&id=ace5ecca"
import script from "./text.vue?vue&type=script&lang=js"
export * from "./text.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ace5ecca')) {
      api.createRecord('ace5ecca', component.options)
    } else {
      api.reload('ace5ecca', component.options)
    }
    module.hot.accept("./text.vue?vue&type=template&id=ace5ecca", function () {
      api.rerender('ace5ecca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/config_center/view/request_listening/components/text/text.vue"
export default component.exports